import * as tslib_1 from "tslib";
import convertPersonaToRecipientPersonaProps from '../utils/convertPersonaToRecipientPersonaProps';
import findReadWriteRecipient from 'owa-readwrite-recipient-well/lib/actions/findReadWriteRecipient';
export default function searchDirectory(getViewState, findControl) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var viewState;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    viewState = getViewState();
                    return [4 /*yield*/, findReadWriteRecipient(viewState, viewState.queryString, true /*searchDirectory*/)];
                case 1:
                    _a.sent();
                    if (findControl) {
                        findControl.updateSuggestions(convertPersonaToRecipientPersonaProps(viewState.findResultSet), true);
                    }
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=searchDirectory.js.map